import { ChangeDetectionStrategy, Component, computed, inject, Inject } from "@angular/core";
import { AccountManualType } from "@bitwarden/web-vault/app/models/types/account.types";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SignalGlowService } from "@bitwarden/web-vault/app/services/signal-glow/signal-glow.service";

const ACCOUNT_MANUAL_TYPES: { key: AccountManualType; title: string; description: string }[] = [
  { key: "bank", title: "accountTypeBankTitle", description: "accountTypeBankDesc" },
  { key: "credit", title: "accountTypeCreditTitle", description: "accountTypeCreditDesc" },
  { key: "stock", title: "accountTypeInvestmentsTitle", description: "accountTypeInvestmentsDesc" },
  { key: "other", title: "accountTypeOtherTitle", description: "accountTypeOtherDesc" },
];

@Component({
  selector: "app-account-type",
  templateUrl: "./account-type.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountTypeComponent {
  protected signalGlowService = inject(SignalGlowService);
  protected readonly ACCOUNT_TYPES = ACCOUNT_MANUAL_TYPES;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      onSelectAccountType: (type: AccountManualType) => void;
    },
  ) {}

  tileButtonClicked(type: AccountManualType) {
    this.data.onSelectAccountType(type);
  }

  // "stock" renders as "investment" in the UI, so the test ID mirrors the label
  private readonly accountTypeAliases: Partial<Record<AccountManualType, string>> = {
    stock: "investment",
  };

  getAccountTypeTestId(key: AccountManualType): string {
    return `account-type-${this.accountTypeAliases[key] ?? key}`;
  }
}
